// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2V8H22V2H2ZM4 4H6.00391V6.00391H4V4Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 10.0005V22.0005H22V10.0005H2ZM5 13.0005L19 13.0005V15.0005L5 15.0005V13.0005ZM5 17.0005H11V19.0005H5V17.0005Z"}}]};

const SystemLogFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'system-log-filled',
    ref,
    icon: element,
  },
));

SystemLogFilledIcon.displayName = 'SystemLogFilledIcon';

export default SystemLogFilledIcon;
